export function renderContact(): string {
  return /* html */`
<div class="page-wrapper contact-page">
  <div class="page-hero">
    <span class="section-label">Contact</span>
    <h1 class="hero-title anim-fade-up">
      <span class="gradient-text">Say something.</span>
    </h1>
    <p class="hero-mission anim-fade-up" style="animation-delay:0.1s">
      Based in Santa Cruz, CA. Available via email and GitHub.
      We read everything. We don't always respond quickly, but we do respond.
    </p>
  </div>

  <div class="page-section contact-layout">
    <!-- Contact form -->
    <div class="contact-form-wrap">
      <h2 class="section-title" style="font-size:var(--text-2xl);margin-bottom:var(--s6)">Send a message</h2>

      <form id="contact-form" class="contact-form" novalidate>
        <div class="form-group">
          <label for="contact-name" class="form-label">Your name</label>
          <input type="text" id="contact-name" name="name" class="form-input"
                 placeholder="Ada Lovelace" required autocomplete="name"/>
        </div>

        <div class="form-group">
          <label for="contact-email" class="form-label">Email</label>
          <input type="email" id="contact-email" name="email" class="form-input"
                 placeholder="ada@example.com" required autocomplete="email"/>
        </div>

        <div class="form-group">
          <label for="contact-subject" class="form-label">Subject</label>
          <select id="contact-subject" name="subject" class="form-input">
            <option value="general">General inquiry</option>
            <option value="collab">Collaboration / partnership</option>
            <option value="business">Business inquiry</option>
            <option value="bug">Bug report</option>
            <option value="hiring">Hiring / careers</option>
            <option value="other">Something else</option>
          </select>
        </div>

        <div class="form-group">
          <label for="contact-message" class="form-label">Message</label>
          <textarea id="contact-message" name="message" class="form-input form-textarea"
                    placeholder="What's on your mind?" required rows="5"></textarea>
        </div>

        <button type="submit" class="btn btn-primary" style="width:100%">
          Send message
        </button>

        <div id="form-result" class="form-result hidden"></div>
      </form>
    </div>

    <!-- Contact info panel -->
    <div class="contact-info-panel">
      <div class="contact-info-card card">
        <h3 class="contact-info-title">Direct lines</h3>
        <ul class="contact-list">
          <li class="contact-item">
            <span class="contact-icon">✉</span>
            <div>
              <div class="contact-item-label">Email</div>
              <a href="mailto:hello@xaebia.com" class="contact-link">hello@xaebia.com</a>
            </div>
          </li>
          <li class="contact-item">
            <span class="contact-icon">🐙</span>
            <div>
              <div class="contact-item-label">GitHub</div>
              <a href="https://github.com/xirtus" class="contact-link" target="_blank" rel="noopener">
                github.com/xirtus ↗
              </a>
            </div>
          </li>
          <li class="contact-item">
            <span class="contact-icon">📍</span>
            <div>
              <div class="contact-item-label">Location</div>
              <span class="contact-link">Santa Cruz, California</span>
            </div>
          </li>
        </ul>
      </div>

      <div class="contact-collab card" style="margin-top:var(--s4)">
        <h3 class="contact-info-title">Collaboration</h3>
        <p style="color:var(--text-2);font-size:var(--text-sm);margin-bottom:var(--s4)">
          We're open to collaborating with other independent developers, designers,
          artists, and researchers. If you're building something interesting and
          think Xaebia could help or contribute, reach out.
        </p>
        <p style="color:var(--text-2);font-size:var(--text-sm)">
          We're especially interested in: local-first applications, AI tools for
          creative work, open-source infrastructure, and anything happening in
          the Santa Cruz tech community.
        </p>
      </div>

      <div class="contact-location card" style="margin-top:var(--s4)">
        <div class="location-visual" aria-hidden="true">
          <div class="location-dot"></div>
          <div class="location-rings"></div>
          <span class="location-label">Santa Cruz, CA 🌊</span>
        </div>
        <p style="color:var(--text-3);font-size:var(--text-xs);margin-top:var(--s3);font-family:var(--font-mono)">
          36.9741° N, 122.0308° W
        </p>
      </div>
    </div>
  </div>
</div>
`;
}

export function initContact(): void {
  const form = document.getElementById('contact-form') as HTMLFormElement;
  const result = document.getElementById('form-result');
  if (!form) return;

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    const btn = form.querySelector('button[type="submit"]') as HTMLButtonElement;
    btn.disabled = true;
    btn.textContent = 'Sending...';

    // Simulate send (replace with real endpoint)
    await new Promise(r => setTimeout(r, 800));

    if (result) {
      result.classList.remove('hidden', 'form-result--error');
      result.classList.add('form-result--success');
      result.innerHTML = `
        <strong>Message received.</strong> We'll be in touch soon.
        <br/><small>In the meantime, check out <a href="https://github.com/xirtus" target="_blank">github.com/xirtus</a>.</small>
      `;
    }
    form.reset();
    btn.disabled = false;
    btn.textContent = 'Send message';

    // TODO: Wire to actual backend (Resend, Formspree, or custom FastAPI endpoint)
  });
}
